// extracted by mini-css-extract-plugin
export const container = "InputField-module--container--Lyudc";
export const content = "InputField-module--content--2Rh0N";
export const input = "InputField-module--input--3hWzq";
export const label = "InputField-module--label--1ueIV";